module.exports = {
  /* 01.General */
  "chat.end":"채팅 대화 다시 시작",
  "chat.endall":"채팅 종료",
  "chat.cancel":"취소",
  "chat.cookie":"이 디지털 비서는 쿠키를 사용하여 최고의 경험을 보장합니다.",
  "chat.learn":"더 알아보기",
  "chat.minimize":"최소화",
  "chat.hide":"닫다",
  "chat.hidebot.text":"닫기를 누르면 아바타가 15분 동안 사라집니다.",
  "chat.hidebot":"봇 닫기",
  "chat.restart":"재시작",
  "switch.language":"언어 전환",
  "switch.property":"속성 전환",
  "restart.converstation":"대화 다시 시작",
  "chat.endtext":"현재 채팅을 종료하시겠습니까?",
  "check.availabity":"가용성 확인",
  "check.availabity.submit":"제출하다",
  "check.availabity.cancel":"취소",
  "check.availabity.adults":"성인 ",
  "check.availabity.children":"어린이들",
  "check.availabity.child.age":"나이 - 아이",
  "feedback.leave":"피드백 남기기",
  "feedback.leave.message":"메시지 남기기",
    "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email" :" Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode":"Zip Code"
};
